import React, {Component} from "react";
import {Link} from "react-router-dom";
import axios from "axios";
import Nav from "./Nav";
import DeleteIcon from "@material-ui/icons/DeleteOutlined";
// import MoreIcon from '@material-ui/icons/MoreHoriz';
import LocationIcon from "@material-ui/icons/LocationOnOutlined";
import TimeIcon from "@material-ui/icons/AccessTime";
import NoArrangementPng from "../images/icon_noArrangement@2x.png";
import {BASE_LINK, MY_RESERVE_DETAIL_LINK, MY_ROOM_RESERVE_URL, CHANGEPASSWORD} from "../actions/types";
import moment from "moment";
import "moment/locale/zh-cn";
import {IconButton, Button, Menu, MenuItem} from "@material-ui/core";
import person from './../images/myWhite.svg'

moment.locale("zh-cn");

class MyReserve extends Component {
  state = {
    reservationFuture: [],
    reservationPre: [],
    anchorEl: null,
  };

  componentDidMount() {
    axios({
      method: "get",
      url: `${MY_ROOM_RESERVE_URL}`,
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("X-AUTH-TOKEN")
      }
    })
      .then(res => {
        if (res.data.futureList) {
          this.setState({
            reservationFuture: res.data.futureList.filter(item => {
              return moment(item.start) > moment()
            }), reservationPre: res.data.pastTimeList.filter(item => {
              return true
            })
          });
        }
      })
      .catch(err => {
        console.log(err.response);
      });
  }

  render() {
    let _this = this;
    return (
      <React.Fragment>
        <div style={{height: "45px", position: "relative", overflow: "hidden"}}>
          <div className="navbar-header" style={{textAlign: "center"}}>
            <Link className="navbar-brand" to={BASE_LINK}>我的</Link>
          </div>
          <div className="navbar-button">
            <Button
              id="basic-button"
              aria-controls="basic-menu"
              aria-haspopup="true"
              onClick={(event) => {
                _this.setState({anchorEl: event.currentTarget})
              }}
            >
              <img src={person}/>
            </Button>
            <Menu
              anchorEl={this.state.anchorEl}
              open={Boolean(_this.state.anchorEl)}
              onClose={(value) => {
                _this.setState({anchorEl: false})
              }}
            >
              <Link className="navbar-brand" to={CHANGEPASSWORD}> <MenuItem onClick={(value) => {
                _this.setState({anchorEl: false})
              }}>修改密码</MenuItem>
              </Link>
              <Link className="navbar-brand" to={'/login'}>
                <MenuItem onClick={(value) => {
                  localStorage.setItem('X-AUTH-TOKEN', "")
                  _this.setState({anchorEl: false});
                }}>退出</MenuItem>
              </Link>
            </Menu>
          </div>
        </div>
        <div className="container" style={{paddingTop: 0}}>
          {this.renderReservations()}
        </div>
        <Nav/>
      </React.Fragment>
    );
  }

  renderReservations() {
    const {reservationFuture, reservationPre} = this.state;
    if (reservationFuture.length === 0 && reservationPre.length === 0) {
      return this.renderEmpty();
    } else {
      return (
        <React.Fragment>
          {this.renderFutureReserve()}
          {this.renderPreReserve()}
        </React.Fragment>
      );
    }
  }

  // 渲染将来的预约
  renderFutureReserve() {
    const {reservationFuture} = this.state;
    if (reservationFuture.length !== 0) {
      let content = reservationFuture.map(data => {
        const {status, start, end, purpose, roomname} = data;
        let statusName = "预约成功";
        if (status === "Apending") {
          statusName = "预约中";
        }
        if (status === "Dcanceled") {
          statusName = "预约取消";
        }
        if (status === "Cfail") {
          statusName = "预约失败";
        }
        return (
          <Link
            key={data.id}
            to={{
              pathname: `${MY_RESERVE_DETAIL_LINK}/${data.roomid}`,
              state: {data: data, isPassed: false}
            }}
            className="reserve-content"
          >
            <div className="reserve-left">
              <div className="reserve-purpose">{purpose}</div>
              <div className="reserve-area">
                <LocationIcon style={{color: "rgba(0,0,0,0.45)", fontSize: 12, marginRight: 5}}/>
                <span>{roomname}</span>
              </div>
              <div className="reserve-time">
                <TimeIcon style={{color: "rgba(0,0,0,0.45)", fontSize: 12, marginRight: 5}}/>
                <span>
									{moment(start).format("MM 月 DD 日 HH:mm")} - {moment(end).format("HH:mm")}
								</span>
              </div>
            </div>
            <div className="my-reserve-right">
              <div className="reserve-result future">{statusName}</div>
              {/*<DeleteIcon hidden={true} style={{ color: "rgba(0,0,0,0.45)", fontSize: 16 }} />*/}
            </div>
          </Link>
        );
      });
      return <section className="my-reserve-list">{content}</section>;
    }
  }

  // 渲染过去的预约
  renderPreReserve() {
    const {reservationPre} = this.state;
    if (reservationPre.length !== 0) {
      let content = reservationPre.map(data => {
        const {status, start, end, purpose, roomname} = data;
        let statusName = "预约成功";
        if (status === "Apending") {
          statusName = "预约中";
        }
        if (status === "Dcanceled") {
          statusName = "预约取消";
        }
        if (status === "Cfail") {
          statusName = "预约失败";
        }
        return (
          <Link
            key={data.id}
            to={{pathname: `${MY_RESERVE_DETAIL_LINK}/${data.roomid}`, state: {data: data, isPassed: true}}}
            className="reserve-content"
          >
            <div className="reserve-left">
              <div className="reserve-purpose">{purpose}</div>
              <div className="reserve-area">
                <LocationIcon style={{color: "rgba(0,0,0,0.45)", fontSize: 12, marginRight: 5}}/>
                <span>{roomname}</span>
              </div>
              <div className="reserve-time">
                <TimeIcon style={{color: "rgba(0,0,0,0.45)", fontSize: 12, marginRight: 5}}/>
                <span>
									预约时间：{moment(start).format("MM 月 DD 日 HH:mm")} - {moment(end).format("HH:mm")}
								</span>
              </div>
            </div>
            <div className="my-reserve-right">
              <div className="reserve-result">{statusName}</div>
              {/*<MoreIcon style={{color:"rgba(0,0,0,0.45)",fontSize:16}}/>*/}
            </div>
          </Link>
        );
      });
      return (
        <section className="my-reserve-list">
          <div style={{textAlign: "center", padding: "16px 0"}}>
            <div className="dash-border"/>
            <span className="dash-span">已失效</span>
          </div>
          {content}
        </section>
      );
    }
  }

  // 渲染没有预约的时候的tips
  renderEmpty() {
    return (
      <div className="reserve-empty">
        <img src={NoArrangementPng} alt="NoArrangementPng" width={72}/>
        <div className="reserve-empty-title">还没有预约记录</div>
      </div>
    );
  }
}

export default MyReserve;
